import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section columns !sm:gap-0 !gap-3 my-rem2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "section lg:text-center" }

import ArticleModalContent from '@/components/ArticleModalContent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Endodontsko',
  emits: ["close", "navigate"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_circular_image = _resolveComponent("a-circular-image")!

  return (_openBlock(), _createBlock(ArticleModalContent, {
    title: _ctx.$t('articles.endodontsko.title'),
    cover: require('@/assets/covers/pregledi-narrow.jpg'),
    "close-button-dark": true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_circular_image, {
          image: require('@/assets/endo2.jpg')
        }, null, 8, ["image"]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.endodontsko.introPre')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.endodontsko.introBold')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.endodontsko.introPost')), 1)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('articles.endodontsko.potekTitle')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('articles.endodontsko.potekP1')), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.endodontsko.potekP2pre')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.endodontsko.potekP2Bold')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.endodontsko.potekP2post')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "max-w-full",
          src: require(`@/assets/endo-shema-1${_ctx.$i18n.locale === 'en' ? '-en' : ''}.jpg`),
          loading: "lazy",
          alt: ""
        }, null, 8, _hoisted_3),
        _createElementVNode("img", {
          class: "max-w-full",
          src: 
                    require(
                        _ctx.$i18n.locale === 'en' ? '@/assets/endo-shema-2-en.jpg' : '@/assets/endo-shema-2.jpg',
                    )
                ,
          loading: "lazy",
          alt: ""
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.endodontsko.potekP3Bold')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.endodontsko.potekP3body')), 1)
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.endodontsko.potekP4pre')), 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.endodontsko.potekP4Bold')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.endodontsko.potekP4post')), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t('articles.endodontsko.potekP5Bold')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('articles.endodontsko.potekP5post')), 1)
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('articles.endodontsko.cenikPre')), 1),
          _createElementVNode("b", {
            class: "internal-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'cenik', 'endodontija')))
          }, _toDisplayString(_ctx.$t('articles.endodontsko.cenikLinkText')), 1),
          _createTextVNode(_toDisplayString(_ctx.$t('articles.endodontsko.cenikPost')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "cover"]))
}
}

})